import { hasProperty, isObject } from '@direct-frontend/stdlib';
import { createErrorMarker } from './createErrorMarker';

export const isNativeError = (instance: unknown): instance is Error => {
    return instance instanceof Error || (isObject(instance) && hasProperty(instance, createErrorMarker('NativeError')));
};
